export type RuntimeImportMeta = {
  env?: {
    DEV?: boolean;
    [key: string]: unknown;
  };
};

export const isViteDevRuntime = (meta?: RuntimeImportMeta) => meta?.env?.DEV === true;

